import React, { useEffect, useState } from 'react'
import { IDataDisplayerItem } from './DataDisplayer'
import DataDisplayerSubItem from './DataDisplayerSubItem'

interface IProps {
    items: Array<IDataDisplayerItem>,
    shown?: boolean,
    handleDeleteItem: (id: number) => void,
}

export default function DataDispplayerSubItems(props: IProps) {

    const { items, shown, handleDeleteItem } = props

    const baseContainerClassName: string = "subitems-of-single-data-displayer-item-box"
    const [containerClassName, setContainerClassName] = useState<string>(baseContainerClassName)

    useEffect(() => {
        if (shown){
            setContainerClassName(`${baseContainerClassName} active`)
        }else{
            setContainerClassName(baseContainerClassName)
        }
    }, [shown])

    if (items.length > 0){

        return(
            <div className={containerClassName}>
                <div className="content-of-subitems-of-single-data-displayer-item-box">
                    {items.map((item, index) => <DataDisplayerSubItem handleDeleteItem={handleDeleteItem} {...item} key={index} />)}
                </div>
            </div>
        )
    }

    return <></>
}